define('app-CarouselComponent/main',['./settings', './modules', '../app-blazy/module'],
    function (settings, modules, blazy) {
        return {
            run: function () {
                var container = $(settings.container);

                if (container.length === 0) {
                    window.log('No Gallery Widgets found.  app-CarouselGalleryComponent will not be available.');
                    return;
                }

                
                $(".carousel").each(function (index) {
                    var slideshow = $(this);
                    modules.sliderControls(slideshow);
                    $(slideshow).carousel('pause');

                    if ($(slideshow).hasClass('offScreen')) {
                        $('.carousel-item', slideshow).each(function () {
                            var next = $(this).next();
                            next.find('.carousel-item_image img').clone().addClass('fadedNext').insertAfter($('.carousel-item_image img', this));
                        });
                    };
                    if ($(window).width() > 992) {
                        controlPosition(slideshow);
                    }
                    $('.carousel-item.active', slideshow, 'img').each(function () {
                        var firstImageUrl = $(this).attr('data-src');
                        $(this).attr('src', firstImageUrl).addClass('b-loaded').removeAttr('data-src');
                    });

                });

                $('.carousel').on('slid.bs.carousel', function (e) {
                    var slideshow = $(this);
                    modules.sliderControls(slideshow);
                    $(slideshow).carousel('pause');
                    blazy.loadLazy();
                    $('.carousel-item .description').removeClass('show');
                    $('.carousel-item .showHide').addClass('collapsed');

                });


                $(window).resize(function () {
                    $(".carousel").each(function (index) {
                        var slideshow = $(this);
                        if ($(window).width() > 992) {

                            controlPosition(slideshow);

                        }
                        else {
                            $('.carousel-control-holder', slideshow).css('top', 'auto')
                            if ($(slideshow).hasClass('product')) {
                                $('.carousel-item_text', slideshow).css('margin-top', '0px')
                            }
                        }
                        
                    });

                    
                });

                function controlPosition(slideshow) {

                    var imgHeight = $('.imageholder img:visible', slideshow).not('.fadedNext').height();
                    $('.carousel-control-holder', slideshow).css('top', imgHeight + 'px');
                    if ($(slideshow).hasClass('product')) {
                        var HeaderHeight = $('.carousel_header', slideshow).height() + 4;
                        $('.carousel-item_text', slideshow).css('margin-top', HeaderHeight + 'px')
                    }
                }  
                
            }
        }
    }
);


